import { useEffect, useState } from 'react';
import './App.css';
import { MotionConfig } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Studio from './components/Studio';
import Works from './components/Works';
import InHouseProject from './components/InHouseProject';
import Software from './components/Software';
import Clients from './components/Clients';
import Footer from './components/Footer';
import { SHOW_SOFTWARE } from './siteConfig';

function App() {
  const [page, setPage] = useState(() => window.location.hash);

  useEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    const handleHashChange = () => setPage(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.history.scrollRestoration = previousRestoration;
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (!page || page === '#') {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      const frame = window.requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));
      return () => window.cancelAnimationFrame(frame);
    }

    const target = document.getElementById(page.slice(1));
    if (target) {
      window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }, [page]);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App bg-[#050505] min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Works />
          <Services />
          <Studio />
          <InHouseProject />
          {SHOW_SOFTWARE && <Software />}
          <Clients />
          <Footer />
        </main>
      </div>
    </MotionConfig>
  );
}

export default App;
